export default [
  {
    key: 'cost',
    name: '总消耗(元)',
    sortable: true,
    filterable: true,
    type: 'target',
    parent: 'impression_click_cost',
  },
  {
    key: 'click_num',
    name: '点击数(次)',
    sortable: true,
    filterable: true,
    type: 'target',
    parent: 'impression_click_cost',
  },
  {
    key: 'actualcost',
    name: '现金消耗(元)',
    sortable: true,
    filterable: true,
    type: 'target',
    parent: 'impression_click_cost',
  },
  {
    key: 'coupon',
    name: '优惠券消耗(元)',
    sortable: true,
    filterable: true,
    type: 'target',
    parent: 'impression_click_cost',
  },
  {
    key: 'cost_change',
    name: '消耗波动',
    filterable: true,
    type: 'target',
    parent: 'impression_click_cost',
  },
  {
    key: 'show_num',
    name: '展现数(次)',
    sortable: true,
    filterable: true,
    type: 'target',
    parent: 'impression_click_cost',
  },
  // {
  //   key: 'request_num',
  //   name: '请求数',
  //   sortable: true,
  //   filterable: true,
  //   type: 'target',
  //   parent: 'impression_click_cost'
  // },
  // {
  //   key: 'served_request_num',
  //   name: '有效请求数',
  //   sortable: true,
  //   filterable: true,
  //   type: 'target',
  //   parent: 'impression_click_cost'
  // },
  // {
  //   key: 'filled_rate',
  //   name: '填充率',
  //   sortable: true,
  //   filterable: true,
  //   type: 'target',
  //   parent: 'impression_click_cost',
  // },
];
